angular.module('portal.i18n').factory('ShareCrfLanguageService', [
    '$window',
    '$cookies',
    '$location',
    'gettextCatalog',
    'i18nUtils',
    /* 'ShareCrfSDK', */
    function ShareCrfLanguageService($window, $cookies, $location, gettextCatalog, i18nUtils /*, ShareCrfSDK */) {
        var browserLanguage = i18nUtils.getFirstBrowserLanguage();
        var language = {
            code: i18nUtils.normalizeLangCode(browserLanguage),
            locale: i18nUtils.normalizeLocale(browserLanguage),
        };

        var LanguageService = {
            langCookieName: 'LANG',
            localeCookieName: 'LOCALE',
        };

        /**
         * Get language
         *
         * @return {Object} Language definition
         */
        LanguageService.getLanguage = function() {
            return language;
        };

        /**
         * Get current language code
         *
         * If cookie is set, this method returns its value. If not, default language code is returned.
         *
         * @return {String} Language code
         */
        LanguageService.getCurrentLanguageCode = function() {
            return $cookies.get(LanguageService.langCookieName) || language.code;
        };
        /**
         * Get current locale
         *
         * If cookie is set, this method returns its value. If not, default locale is returned.
         *
         * @return {String} Locale
         */
        LanguageService.getCurrentLocale = function() {
            return $cookies.get(LanguageService.localeCookieName) || language.locale;
        };

        /**
         * Initialize language
         *
         * Apply current language in external services: gettext, moment, trnggrid
         *
         * @param  {String} lang   Language code
         * @param  {String} locale Locale
         */
        LanguageService.initializeLanguage = function(lang, locale) {
            language.code = lang;
            language.locale = locale;

            // angular-gettext config
            gettextCatalog.setCurrentLanguage(lang);
            gettextCatalog.debug = false;

            // Moment
            var moment = $window.moment;
            if (moment) {
                var momentLocale = i18nUtils.normalizeMomentLocale(locale);
                moment.locale(momentLocale);
            }

            // TrNgGrid language settings
            var TrNgGrid = $window.TrNgGrid;
            if (TrNgGrid) {
                if (angular.isUndefined(TrNgGrid.translations)) {
                    TrNgGrid.translations = {};
                }
                // Lo que hacemos es, como el idioma por defecto es 'es' y está puesto a pelo
                // en el código, sobreescribimos ese idioma. De otro modo, nos obligaría a ir tabla
                // por tabla y añadir el parámetro locale en cada HTML
                var defaultTranslation = {
                    en: {},
                    es: {
                        'Search': 'Buscar',
                        'Page': 'Página',
                        'First Page': 'Primera página',
                        'Next Page': 'Siguiente página',
                        'Previous Page': 'Página anterior',
                        'Last Page': 'Última página',
                        'Sort': 'Ordenar',
                        'No items to display': 'No hay elementos a mostrar',
                        'displayed': 'mostrados',
                        'in total': 'en total',
                    },
                    de: {
                        'Search': 'Suche',
                        'Page': 'Seite',
                        'First Page': 'Erste Seite',
                        'Next Page': 'Nächste Seite',
                        'Previous Page': 'Vorherige Seite',
                        'Last Page': 'Letzte Seite',
                        'Sort': 'Sortieren',
                        'No items to display': 'Keine Elemente zum Anzeigen',
                        'displayed': 'angezeigt',
                        'in total': 'insgesamt',
                    },
                    pt: {
                        'Search': 'Pesquisar',
                        'Page': 'Página',
                        'First Page': 'Primeira página',
                        'Next Page': 'Próxima página',
                        'Previous Page': 'Página anterior',
                        'Last Page': 'Última página',
                        'Sort': 'Ordenar',
                        'No items to display': 'Não há itens para mostrar',
                        'displayed': 'mostrados',
                        'in total': 'no total',
                    },
                };
                TrNgGrid.translations.en = defaultTranslation[lang];
                TrNgGrid.translations.de = defaultTranslation[lang];
                TrNgGrid.translations.pt = defaultTranslation[lang];

                if (TrNgGrid.translationDateFormat) {
                    var defaultTranslationDateFormat = {
                        en: 'yyyy-MM-dd',
                        es: 'dd/MM/yyyy',
                        de: 'dd.MM.yyyy',
                        pt: 'dd/MM/yyyy',
                    };
                    TrNgGrid.translations.en[TrNgGrid.translationDateFormat] = defaultTranslationDateFormat[lang];
                    TrNgGrid.translations.de[TrNgGrid.translationDateFormat] = defaultTranslationDateFormat[lang];
                    TrNgGrid.translations.pt[TrNgGrid.translationDateFormat] = defaultTranslationDateFormat[lang];
                }
            }

            // SDK
            // TODO ¿Es necesario enviar el locale al servidor?
            // ShareCrfSDK.addHeader('X-ShareCRF-Locale', locale);
        };

        /**
         * Set language
         *
         * Set cookie value with given language and initialize services
         *
         * @param {String} lang   Language code
         * @param {String} locale Locale
         */
        LanguageService.setLanguage = function(lang, locale) {
            // GARU-4100 Se normaliza el código de idioma
            var langCode = i18nUtils.normalizeLangCode(lang);
            var localeCode = i18nUtils.normalizeLocale(locale || lang); // GARU-5109 Usa lang como fallback si no hay locale

            // Set cookies
            var cookieDomain = $location.host();
            cookieDomain = cookieDomain.split('.');
            cookieDomain.shift();

            $cookies.put(LanguageService.langCookieName, langCode, {
                domain: cookieDomain.join('.'),
            });
            $cookies.put(LanguageService.localeCookieName, localeCode, {
                domain: cookieDomain.join('.'),
            });

            // Initialize language
            LanguageService.initializeLanguage(langCode, localeCode);
        };

        /**
         * Reload
         *
         * Load language from cookie and initialize services if cookie is set
         */
        LanguageService.reload = function() {
            var lang = $cookies.get(LanguageService.langCookieName);
            var locale = $cookies.get(LanguageService.localeCookieName);

            if (lang && locale) {
                LanguageService.initializeLanguage(lang, locale);
            }
        };

        /**
         * Initialize
         *
         * Init application languge from cookie or default value if it is not set
         */
        LanguageService.initialize = function() {
            var lang = LanguageService.getCurrentLanguageCode();
            var locale = LanguageService.getCurrentLocale();

            LanguageService.setLanguage(lang, locale);
        };

        return LanguageService;
    },
]);
